import { LitElement, html, nothing } from 'lit';
import { dispatchEvent } from '@fil-global/shared/src/util';

import componentStyles from './fil-modal-content.styles.js';

/**
 * @tag fil-modal-content
 * @property {string} [imageAlt]
 * @property {string} [imageSrc]
 */
export class FilModalContent extends LitElement {
  static properties = {
    imageAlt: { type: String },
    imageSrc: { type: String },
  };

  static styles = [componentStyles];

  imageTemplate() {
    if (this.imageSrc) {
      dispatchEvent(this, 'has-image.gds.modal', {
        value: this.imageSrc,
        name: 'content',
      });

      return html`<div class="fil-modal__image">
        <img src=${this.imageSrc} alt=${this.imageAlt} />
      </div>`;
    }

    dispatchEvent(this, 'has-image.gds.modal', {
      value: '',
      name: 'content',
    });
    return nothing;
  }

  render() {
    return html`<div class="fil-modal__content">
      ${this.imageTemplate()}
      <slot></slot>
    </div>`;
  }
}

export default FilModalContent;
